var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-build',{ref:"repayForm",attrs:{"form-data":_vm.form,"form-columns-group":_vm.formColumnsGroup,"form-rules":_vm.formRules,"form-buttons":_vm.formButtons,"form-name":"RepayForm","label-width":"150px","inline":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10cd1f96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/RepayForm.vue
// module id = null
// module chunks = 